import { useContext, useEffect, useState } from "react";
import { Button, Dropdown, Input } from "semantic-ui-react";
import { askMessage, openMessage } from "../Modal";
import api from "../context/api";
import { ProductContext } from "../context/productContext";
import AccordionItem from "./AccordionItem";

function CombinePage() {
  const { getProductCombines, getProductPartGroups, getProductMaterials, id } =
    useContext(ProductContext);

  const [combines, setCombines] = useState([]);

  const [productParts, setProductParts] = useState([]);
  const [productMaterials, setProductMaterials] = useState([]);

  useEffect(async () => {
    setCombines(await getProductCombines());
    setProductParts(convertPartToDropDownOption(await getProductPartGroups()));
    setProductMaterials(
      convertMaterialToDropDownOption(await getProductMaterials())
    );
  }, []);

  const convertPartToDropDownOption = (ps) => {
    return ps.map((p) => {
      return {
        text: p.title,
        key: p.id,
        value: p.id,
      };
    });
  };

  const convertMaterialToDropDownOption = (ps) => {
    if (!ps) return {};
    return ps.map((p) => {
      return {
        text: p.name,
        key: p.id,
        value: p.id,
      };
    });
  };

  const handleChangePart = (i, ii, partId) => {
    setCombines(
      combines.map((pvo, vi) => {
        if (i == vi) {
          const options = [...pvo.options];
          options[ii].partId = partId;
          return { ...pvo, products: options };
        }
        return pvo;
      })
    );
  };

  const handleChangeMaterial = (i, ii, materialId) => {
    setCombines(
      combines.map((pvo, vi) => {
        if (i == vi) {
          const options = [...pvo.options];
          options[ii].materialId = materialId;
          return { ...pvo, products: options };
        }
        return pvo;
      })
    );
  };

  const handleDeleteCombineOption = (i, ii) => {
    setCombines(
      combines.map((pvo, vi) => {
        if (i == vi) {
          const options = pvo.options.filter((o, vii) => {
            return ii != vii;
          });
          return { ...pvo, options: options };
        }
        return pvo;
      })
    );
  };

  const handleChangeName = (i, name) => {
    setCombines(
      combines.map((pvo, vi) => {
        if (i == vi) {
          return { ...pvo, name: name };
        }
        return pvo;
      })
    );
  };

  const handleAddCombine = () => {
    setCombines([...combines, { name: "", options: [], productId: id }]);
  };

  const handleAddCombineOption = (i, ii) => {
    setCombines(
      combines.map((pvo, vi) => {
        if (i == vi) {
          pvo.options.push({ partId: 0, materialId: 0 });
        }
        return pvo;
      })
    );
  };

  const handleDeleteCombine = (index) => {
    if (!combines[index].id || combines[index].id == 0) {
      setCombines(
        combines.filter((vo, iii) => {
          return iii != index;
        })
      );
      return;
    }
    askMessage(
      "Konbin Silinecektir...",
      async () => {
        console.log("combine", combines);
        await api.deleteProductCombine(combines[index].id);
        setCombines([...(await getProductCombines(true))]);
        openMessage("Konbin Silindi...", true);
      },
      () => {}
    );
  };

  const handleSaveCombine = async (index) => {
    openMessage("Konbin Kaydediliyor...");
    try {
      await api.saveProductCombine(combines[index]);
      setCombines([...(await getProductCombines(true))]);
      openMessage("Konbin Kaydedildi...", true);
    } catch (e) {
      openMessage("Konbin Kaydedilirken hata oluştu...", true);
    }
  };

  return (
    <AccordionItem header="Conbine" key={"combine-root-accordion"}>
      <div
        key={"combine-root"}
        style={{
          color: "#FFF",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "5px",
        }}
      >
        {combines.map((mo, i) => {
          return (
            <div key={"combines-" + i} className="panel-group">
              <div
                key={"combine-option-product-key-" + i}
                style={{
                  flexGrow: "1",
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                }}
              >
                <div className="panel-group">
                  <Input
                    key={"name_" + i}
                    type="input"
                    id={"name_" + mo.id}
                    value={mo.name}
                    style={{ width: "100%", maxWidth: "200px" }}
                    onChange={(e, o) => {
                      handleChangeName(i, o.value);
                    }}
                  />
                </div>

                <div
                  style={{ display: "flex", flexDirection: "row", gap: "2px" }}
                >
                  {mo.options.map((moo, ii) => {
                    return (
                      <div
                        key={"conbine-row-" + ii}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          maxWidth: "200px",
                          gap: "2px",
                        }}
                        className="panel-group"
                      >
                        <div style={{ flexGrow: 1 }}>
                          <Dropdown
                            id={"pp_" + ii}
                            key={"pp_" + ii}
                            options={productParts}
                            placeholder="Part"
                            fluid
                            floating
                            selection
                            search
                            onChange={(e, o) => {
                              handleChangePart(i, ii, o.value);
                            }}
                            value={moo.partId}
                          ></Dropdown>
                          <Dropdown
                            id={"pm_" + ii}
                            key={"pm_" + ii}
                            options={productMaterials}
                            placeholder=" Material"
                            fluid
                            floating
                            selection
                            search
                            onChange={(e, o) => {
                              handleChangeMaterial(i, ii, o.value);
                            }}
                            value={moo.materialId}
                          ></Dropdown>
                        </div>
                        <div>
                          <Button
                            color="red"
                            className="panel-button"
                            onClick={() => {
                              handleDeleteCombineOption(i, ii);
                            }}
                          >
                            x
                          </Button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div
                key={"combine-option-action-key-" + i}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  gap: "1px",
                }}
              >
                <Button
                  className="panel-button"
                  key={"combine-option-delete-key-" + i}
                  color="red"
                  onClick={(e) => {
                    handleDeleteCombine(i);
                  }}
                >
                  x
                </Button>
                <Button
                  className="panel-button"
                  key={"combine-option-add-key-" + i}
                  color="blue"
                  onClick={(e) => {
                    handleAddCombineOption(i);
                  }}
                >
                  {" "}
                  +
                </Button>
                <Button
                  className="panel-button"
                  key={"combine-option-save-key-" + i}
                  positive
                  onClick={(e) => {
                    handleSaveCombine(i);
                  }}
                >
                  {" "}
                  o
                </Button>
              </div>
            </div>
          );
        })}
        <div
          key={"combine-action-panel"}
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="panel-group"
        >
          <Button
            color="blue"
            onClick={handleAddCombine}
            className="panel-button"
          >
            +
          </Button>
        </div>
      </div>
    </AccordionItem>
  );
}

export default CombinePage;
